export const fields = {
  address: 'address',
  homeAddress: 'homeAddress',
  congestionZone: 'congestionZone',
  agentTip: 'agentTip',
  postcode: 'postcode',
  // Book & pay's one "Car location" box while the address lookup is on
  // (lib/car-location.js): what it shows, whether an address was picked from
  // its list (postcode and address then hold the pick), and whether the
  // customer chose to type the postcode and house number instead.
  carLocation: 'carLocation',
  addressPicked: 'addressPicked',
  locationManual: 'locationManual',
  // The booker's mobile, typed on Book & pay above both pay buttons.
  mobile: 'mobile',
  date: 'date',
  timeSlot: 'timeSlot',
  // Booking form splits make + model into two inputs for UX; we combine
  // them into a single carModel string before dispatching to redux, which
  // stays as the canonical "Make Model" value the API + admin consume.
  carMake: 'carMake',
  carModel: 'carModel',
  carColor: 'carColor',
  carSize: 'carSize',
  carRegistration: 'carRegistration',
  notes: 'notes',
  selectedServiceIds: 'selectedServiceIds'
}
